import { useState } from "react";
import { VideoSectionState, VideoPlayerHandlers } from "./commonTypes";

export function useVideoSection(): VideoSectionState & VideoPlayerHandlers {
  const [isVideoVisible, setIsVideoVisible] = useState(true);
  const [isVideoExpanded, setIsVideoExpanded] = useState(false);

  const handleTimestampClick = (startTime: number) => {
    if (!isVideoVisible) {
      setIsVideoVisible(true);
      setTimeout(() => {
        const iframe = document.querySelector<HTMLIFrameElement>("iframe");
        if (iframe?.contentWindow) seekAndPlayVideo(iframe, startTime);
      }, 1000);
    } else {
      const iframe = document.querySelector<HTMLIFrameElement>("iframe");
      if (iframe?.contentWindow) seekAndPlayVideo(iframe, startTime);
    }
  };

  const seekAndPlayVideo = (iframe: HTMLIFrameElement, startTime: number) => {
    const message = JSON.stringify({
      event: "command",
      func: "seekTo",
      args: [startTime],
    });
    iframe.contentWindow?.postMessage(message, "*");

    setTimeout(() => {
      const playMessage = JSON.stringify({
        event: "command",
        func: "playVideo",
        args: [],
      });
      iframe.contentWindow?.postMessage(playMessage, "*");
    }, 100);
  };

  return {
    isVideoVisible,
    isVideoExpanded,
    setIsVideoVisible,
    setIsVideoExpanded,
    handleTimestampClick,
    seekAndPlayVideo,
  };
}
